export default "__VITE_ASSET__5c040f40__"